import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from 'semantic-ui-react';
import { getItemTemplate, LinkMore } from '@package/components';

const InEvidenzaTemplate = (data) => {
  const { items, isEditMode } = data;

  const FirstItem = items[0] ? getItemTemplate(items[0]) : null;
  const SecondItem = items[1] ? getItemTemplate(items[1]) : null;
  const ThirdItem = items[2] ? getItemTemplate(items[2]) : null;

  const otherItems = items.length > 3 ? items.slice(3) : [];

  const align =
    otherItems.filter((i) => i['@type'] === 'SchedaTematica').length ===
    otherItems.length
      ? 'bottom'
      : 'top';

  const getItemTemplateParams = (item) => {
    switch (item['@type']) {
      case 'Esperienza':
        return { showMunicipality: false, showPrice: false };
      default:
        return {};
    }
  };

  return items.length > 0 ? (
    <div className="inevidenza-template">
      <Grid stackable verticalAlign="top">
        <Grid.Row stretched>
          <Grid.Column width={7} className="primary-items">
            {FirstItem && (
              <FirstItem
                item={items[0]}
                isEditMode={isEditMode}
                withTags={true}
                infoInTitle={true}
                {...getItemTemplateParams(items[0])}
              />
            )}
          </Grid.Column>
          <Grid.Column width={5} className="secondary-items">
            {SecondItem && (
              <SecondItem
                item={items[1]}
                isEditMode={isEditMode}
                withTags={true}
                infoInTitle={true}
                {...getItemTemplateParams(items[1])}
              />
            )}

            {ThirdItem && (
              <ThirdItem
                item={items[2]}
                isEditMode={isEditMode}
                withTags={true}
                infoInTitle={true}
                {...getItemTemplateParams(items[2])}
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid columns={4} stackable verticalAlign={align} className="other-items">
        {otherItems.map((item) => {
          let ItemTemplate = getItemTemplate(item);

          return (
            <Grid.Column key={item['@id']}>
              <ItemTemplate
                item={item}
                isEditMode={isEditMode}
                withTags={true}
                {...getItemTemplateParams(item)}
              />
            </Grid.Column>
          );
        })}
      </Grid>

      <LinkMore {...data} />
    </div>
  ) : null;
};

InEvidenzaTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default InEvidenzaTemplate;
